import { connect } from "react-redux";
import { provideLocationState } from "components/utility/hoc/LocationState";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { Link } from "react-router-dom";

var CurrentUser = require("lib/account/CurrentUser");
var ClassTree = require("components/org/student_lists/ClassTree");
var PhotosDisplay = require("components/social/photos/PhotosDisplay");
var BookShelf = require("components/reading/shelves/BookShelf");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var Spinner = require("components/utility/Spinner");
var StudentListDropdownDisplay = require("components/org/StudentListDropdownDisplay");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");

var ClassPageRouting = require("lib/routing/ClassPageRouting");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var OrgTypes = require("lib/academic/OrgTypes");
var OrgDropdown = require("components/org/OrgDropdown");

var OwlShopRouting = require("lib/routing/OwlShopRouting")


require("org/student_lists/class_page.scss");

@provideLocationState(ClassPageRouting.getRouteState)
@connect(
	(state, props) => {
		var orgIdentifier = props.locationState.orgIdentifier;
		if (CurrentUser.isAdmin()) {
			var studentLists = RosterSelectors.nonEmptyStudentLists({ state });
			if (orgIdentifier == ClassPageRouting.DEFAULT_ORG_IDENTIFIER_KEY) {
				if (studentLists.length > 0) {
					orgIdentifier = OrgTypes.toIdentifier({ type: OrgTypes.STUDENT_LIST, key: studentLists[0].id });
				} else {
					orgIdentifier = null;
				}
			}
		} else {
			if (orgIdentifier == ClassPageRouting.DEFAULT_ORG_IDENTIFIER_KEY) {
				orgIdentifier = OrgTypes.toIdentifier({ type: OrgTypes.STUDENT_LIST, key: CurrentUser.get().primary_student_list.id });
			}
		}
		if (orgIdentifier) {
			var students = RosterSelectors.studentsForOrgIdentifier({ state, orgIdentifier });
			var studentListID = OrgTypes.fromIdentifier(orgIdentifier).key;
		}

		var isLoadingStudentLists = RosterSelectors.isLoadingStudentLists({ state, key: studentListID });
		if (CurrentUser.isAdmin()) {
			return {
				students,

				showClassShelf: true,
				allowChangeClass: true,
				orgIdentifier: orgIdentifier,

				isLoadingStudentLists
			}
		} else {
			return {
				students,
				isStudent: true,
				showClassShelf: CurrentUser.get().prefs.display_class_shelf,
				allowChangeClass: false,
				orgIdentifier: orgIdentifier,

				isLoadingStudentLists
			}
		}
	},

	(dispatch, props) => {
		var fetchStudentList = (id) => {
			var embeds = [
				"student_list.primary_admin", "student_list.students",
				"student.avatar", "student.settings", "student.perks",
				"student.student_list_ids"
			]

			return dispatch(RosterActions.fetchStudentList({
				id, embeds
			}));
		}

		var populateData = () => {
			return dispatch((dispatch, getState) => {
				// This one loads in some extra stuff that's not (currently) covered in the
				// fetchRosterData action from App.js
				// Plus students need it to be loaded in

				if (props.locationState.orgIdentifier == ClassPageRouting.DEFAULT_ORG_IDENTIFIER_KEY) {
					if (CurrentUser.isAdmin()) {
						var studentList = RosterSelectors.nonEmptyStudentLists({
							state: getState()
						});

						if (!studentList || !studentList.length) {
							var studentList = RosterSelectors.studentLists({
								state: getState()
							});							
						}

						if (_.isEmpty(studentList)) {
							var studentListID = !_.isEmpty(CurrentUser.get().student_list_ids) ? CurrentUser.get().student_list_ids[0] : null;
						} else {
							var studentListID = studentList[0].id
						}

					} else {
						var studentListID = CurrentUser.get().primary_student_list.id;
					}
				} else {
					var studentListID = OrgTypes.fromIdentifier(props.locationState.orgIdentifier).key;
				}
				return studentListID ? fetchStudentList(studentListID) : null;
			})
		}

		return {
			populateData, fetchStudentList

		}
	}
)
@providePopulateData()

class ClassPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("ClassPage");
		this.state = {};
	}

	//////////////////////////////////////
	// Redirecting to change the view ////
	//////////////////////////////////////

	switchActiveView(viewKey) {
		Mycroft.newEvent({ category: "Class Page", action: "toggle-view", label: viewKey });
		this.switchView({ activeView: viewKey });
	}

	switchView(change) {
		var newLocationState = _.extend({}, this.props.locationState, change);
		$wr.redirect(ClassPageRouting.getPath(newLocationState));
	}
	
	//////////////////////////////////////
	// Rendering /////////////////////////
	//////////////////////////////////////

	renderNoStudentsEmptyState() {
		var rosterLink = "/roster?add_students=true";
		var emptyActionText = (
			<p>
				It looks like you haven't added any students yet.
				<Link to={ rosterLink }> Add students </Link> 
				and their books and book reviews will appear here.
			</p>
		)
		var emptyImgPath = require("empty-state/class-shelf.png");
		return (
			<EmptyStateContainer actionText={ emptyActionText }
				linkPath={ rosterLink } imagePath={ emptyImgPath } />
		);
	}

	onOrgSelect(orgIdentifier) {
		var studentListID = OrgTypes.fromIdentifier(orgIdentifier).key;
		this.props.fetchStudentList(studentListID);

		$wr.redirect(ClassPageRouting.getPath({
			activeView: this.props.locationState.activeView,
			orgIdentifier
		}));
	}

	render() {
		var lState = this.props.locationState;

		var toggleOptions = [
			{ key: ClassPageRouting.VIEWS.TREE_VIEW, text: "Tree" },
			{ key: ClassPageRouting.VIEWS.PHOTO_VIEW, text: "Owlstagram" },
		];

		
		if (this.props.showClassShelf) {
			toggleOptions.push({ key: ClassPageRouting.VIEWS.SHELF_VIEW, text: "Shelf" })
		}

		var displayToggleControl = (
				<DisplayToggleControl options={ toggleOptions }
				onChange={ this.switchActiveView }
				activeOptionKey={ lState.activeView } />
		);

		if (this.props.isLoadingStudentLists) {
			var classContentDisplay = (
				<Spinner placeholder={ true }  scale={ 1.7 } />
			);

		} else if (this.props.allowChangeClass && _.isEmpty(this.props.students)) {
			var classContentDisplay = this.renderNoStudentsEmptyState()

		} else if (lState.activeView == ClassPageRouting.VIEWS.SHELF_VIEW) {
			var classContentDisplay = (
				<BookShelf classView key={ this.props.orgIdentifier }
					studentIDs={ _.pluck(this.props.students, "id") }
					detailsView={ lState.detailsView }
					textID={ lState.textID }
					switchView={ this.switchView } />
			);
		} else if (lState.activeView == ClassPageRouting.VIEWS.TREE_VIEW) {
			var classContentDisplay = (
				<ClassTree students={ this.props.students } />
			);
			if (this.props.isStudent) {
				var owlShopLink = (
					<div class = "owlShopLink">
					<a href = "/owl_shop">Visit the Owl Shop!</a>
					</div>
				)
			}
			
		} else if (lState.activeView == ClassPageRouting.VIEWS.PHOTO_VIEW) {
			var studentIDs = _.pluck(this.props.students, "id")
			var classContentDisplay = (
				<PhotosDisplay 
				isClass = {true}
				ids = {studentIDs}  />				
			);

			if (this.props.isStudent) {
				var owlShopLink = (
					<div className = "text-center">
						<Link to={ OwlShopRouting.getPath({ activeView: OwlShopRouting.VIEWS.PHOTOS }) }> 
						Snap a photo!
						</Link>
					</div>
				)
			}
		}
		var controlsClassName = "viewControls";

		if (!this.props.isLoadingStudentLists && this.props.orgIdentifier && !this.props.isStudent) {
			var selectionTypes = [OrgTypes.STUDENT_LIST, OrgTypes.SUBGROUP];
			var selector = (
				<div className="text-center">
					<OrgDropdown dropdownDisplay="link" 
					selectedIdentifier={ this.props.orgIdentifier }
					onSelect={ this.onOrgSelect } 
					selectionTypes={ selectionTypes } />
				</div>

			);
		}
		return (
			<div className="container classPage" ref="page">
				<header className="pageHeader">
					<h1>My Class</h1>
				</header>
				<div className="linksGroup">
					<div className={ controlsClassName }>
						{ displayToggleControl }
						{ selector }
						{ owlShopLink }
					</div>
				</div>
					{ classContentDisplay }
			</div>
		)
	}
};

ClassPage.WrappedComponent.propTypes = PageStrictPropTypes({
	locationState: PropTypes.object.isRequired,

	// @connect data
	studentList: PropTypes.object,
	students: PropTypes.array,
	showClassShelf: PropTypes.bool,
	allowChangeClass: PropTypes.bool,
	isLoadingStudentLists: PropTypes.bool,
	orgIdentifier: PropTypes.string,

	// @connect handler
	populateData: PropTypes.func,
	fetchStudentList: PropTypes.func

});

module.exports = ClassPage;



// WEBPACK FOOTER //
// ./modules/components/org/student_lists/ClassPage.js